module.exports = __webpack_public_path__ + "img/we-are-hiring-dark.9a02d73e.svg";